import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function getFanDashboard(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}fanapis/dashboard`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to load dashboard"
    };
  }
}

export async function getFanFeed(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("page", payload.page ?? 0);

    const res = await axios.post(`${apiBaseUrl}fanapis/feed`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to load activity feed"
    };
  }
}

export async function getEngagementChart(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}fanapis/engagement_chart`, fd);
    return res.data;

  } catch (err) {
    return { status: false };
  }
}

export async function getActivityChart(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}fanapis/activity_chart`, fd);
    return res.data;

  } catch (err) {
    return { status: false };
  }
}

export async function getFanSettings(user_id) {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}fanapis/get_settings`, fd);
    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Failed to load settings" };
  }
}

export const votePollApi = async (data) => {
  try {

    const formData = new FormData();

    formData.append("user_id", data.user_id);
    formData.append("content_id", data.content_id);
    formData.append("option", data.option);

    const res = await axios.post(
      apiBaseUrl + "fanapis/vote_poll",
      formData
    );

    return res.data;

  } catch (err) {
    return {
      status: false,
      success: "API error"
    };
  }
};

export async function getFanSettings1(payload) {
  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");

    const res = await axios.post(
      `${apiBaseUrl}fanapis/get_fan_settings`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function saveFanSettingsApi(payload) {
  try {

    const fd = new FormData();

    // ================= BASIC PROFILE =================
    fd.append("user_id", payload.user_id || "");
    fd.append("gender", payload.gender || "");
    fd.append("age_range", payload.age_range || "");
    fd.append("occupation", payload.occupation || "");
    fd.append("income", payload.income || "");
    fd.append("city_tier", payload.city_tier || "");
    fd.append("platform", payload.platform || "");
    fd.append("country", payload.country || "");

    // ================= SEGMENT 2 =================
    fd.append("purchased", payload.purchased || "");
    fd.append("spending", payload.spending || "");
    fd.append("categories", payload.categories || "");

    // ================= SEGMENT 3 =================
    fd.append("discount_code", payload.discount_code || "");
    fd.append("purchase_frequency", payload.purchase_frequency || "");
    fd.append("price_sensitivity", payload.price_sensitivity || "");
    fd.append("clicked_link", payload.clicked_link || "");
    fd.append("education", payload.education || "");

    const res = await axios.post(
      `${apiBaseUrl}fanapis/save_fan_settings1`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function saveFanSettings(payload) {
  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("occupation", payload.occupation);
    fd.append("education", payload.education);
    fd.append("interests", JSON.stringify(payload.interests));

    fd.append("consent", payload.consent);
    fd.append("reminders", payload.reminders);

    const res = await axios.post(`${apiBaseUrl}fanapis/save_settings`, fd);
    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Save failed" };
  }
}

export async function updateFanProfile(payload) {
  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("user_name", payload.user_name);
    fd.append("user_mobile", payload.user_mobile);

    const res = await axios.post(`${apiBaseUrl}fanapis/update_profile`, fd);
    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Update failed" };
  }
}

export async function changeFanPassword(payload) {
  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("current_password", payload.current_password);
    fd.append("new_password", payload.new_password);

    const res = await axios.post(`${apiBaseUrl}fanapis/change_password`, fd);
    return res.data;

  } catch (err) {
    return { status: false, type: "danger", success: "Password change failed" };
  }
}

export async function saveBasicProfileApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");
    fd.append("gender", payload.gender || "");
    fd.append("age_range", payload.age_range || "");
    fd.append("occupation", payload.occupation || "");
    fd.append("income", payload.income || "");
    fd.append("city_tier", payload.city_tier || "");
    fd.append("platform", payload.platform || "");
    fd.append("country", payload.country || "");

    const res = await axios.post(
      `${apiBaseUrl}fanapis/save_basic_profile`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}
export async function getBasicProfileApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");

    const res = await axios.post(
      `${apiBaseUrl}fanapis/get_basic_profile`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function getBasicProfileApi1(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");

    const res = await axios.post(
      `${apiBaseUrl}fanapis/get_basic_profile1`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function getBasicProfileApi2(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");

    const res = await axios.post(
      `${apiBaseUrl}fanapis/get_basic_profile2`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

export async function saveSegment2Api(payload) {

  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("purchased", payload.purchased);
    fd.append("spending", payload.spending);
    fd.append("categories", payload.categories);

    const res = await axios.post(
      `${apiBaseUrl}fanapis/save_segment2`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch {

    return { status: false };

  }

}

export async function saveSegment3Api(payload) {

  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("discount_code", payload.discount_code);
    fd.append("purchase_frequency", payload.purchase_frequency);
    fd.append("price_sensitivity", payload.price_sensitivity);
    fd.append("clicked_link", payload.clicked_link);
    fd.append("education", payload.education);

    const res = await axios.post(
      `${apiBaseUrl}fanapis/save_segment3`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch {
    return { status: false };
  }

}